export function getLegalDocUrl(prestid: string | number): string {
    const host = process.env.VUE_APP_WEBSITE || (window.location.hostname == 'localhost' ? 'www.travelski.com' : window.location.hostname)
    if (typeof window === "undefined" || !window.location?.hostname) {
        throw new Error("window.location.hostname is unavailable")
    }

    return `https://docs.travelski.com/legal-docs/${host}/${prestid}/index.pdf`
}
